import { AttributeTreeData } from './attribute-tree-data';
import { AggregateFunction } from './report-column-aggregate-function';

export class Field {
    public id: number | null;
    public displayName: string;
    public customDisplayName: string | null;
    public name: string;
    public description: string;
    public dataType: string;
    public entityTypeId?: number | null;
    public entityTypeName: string;
    public entityTypeDisplayName: string;
    public selectable: boolean;
    public nodeId: string;
    public fullName: string;
    public dataTypeName: string;
    public isForeignKey: boolean;
    public foreignKeyTable: string;
    public aggregateType: number | null;

    public get isAggregate(): boolean {
        return this.aggregateType != null && Number(this.aggregateType) !== 6;
    }

    public get currentDisplayName(): string {
        return this.customDisplayName != null
            ? this.customDisplayName
            : this.displayName;
    }

    private editingDisplayName: boolean = false;
    private tempCustomDisplayName: string | null;

    public editDisplayName() {
        this.editingDisplayName = true;

        this.tempCustomDisplayName = this.currentDisplayName;
    }

    public acceptDisplayName() {
        if (this.tempCustomDisplayName != null && this.tempCustomDisplayName.length > 0) {
            this.customDisplayName = this.tempCustomDisplayName;
        } else {
            this.tempCustomDisplayName = null;
        }
        this.editingDisplayName = false;
    }

    public rejectDisplayName() {
        this.tempCustomDisplayName = null;
        this.editingDisplayName = false;
    }

    public constructor(attributeTreeData?: AttributeTreeData & { aggregateType?: AggregateFunction | null }) {
        if (!attributeTreeData) {
            return;
        }

        this.id = attributeTreeData.id;
        this.displayName = attributeTreeData.displayName;
        this.customDisplayName = attributeTreeData.customDisplayName;
        this.name = attributeTreeData.name;
        this.description = attributeTreeData.description;
        this.dataType = attributeTreeData.dataType;
        this.entityTypeId = attributeTreeData.entityTypeId;
        this.entityTypeName = attributeTreeData.entityTypeName;
        this.entityTypeDisplayName = attributeTreeData.entityTypeDisplayName;
        this.selectable = attributeTreeData.selectable;
        this.nodeId = attributeTreeData.nodeId;
        this.fullName = attributeTreeData.fullName;
        this.dataTypeName = attributeTreeData.dataTypeName;
        this.isForeignKey = attributeTreeData.isForeignKey;
        this.foreignKeyTable = attributeTreeData.foreignKeyTable;
        this.aggregateType = attributeTreeData.aggregateType || null;
    }
}
